module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gamehead"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("2048")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "score"
  }, [_c('span', {
    staticClass: "type"
  }, [_vm._v("score")]), _vm._v(" " + _vm._s(_vm.score) + "\n    "), _c('span', {
    ref: "plus",
    class: {
      'addScore': _vm.addScore
    },
    staticStyle: {
      "position": "absolute",
      "right": "30px",
      "opacity": "0",
      "color": "#444",
      "font-size": "16px"
    }
  }, [_vm._v("+" + _vm._s(_vm.addScore))])]), _vm._v(" "), _c('span', {
    staticClass: "score"
  }, [_c('span', {
    staticClass: "type"
  }, [_vm._v("best")]), _vm._v(" " + _vm._s(_vm.bestScore))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0b6b2a5e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/gamehead/index.vue
// module id = 34
// module chunks = 0